import client from './client';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

/**
 * @typedef {Object} OwnDeclaration
 */

const URL = 'custom-declaration/';
const URL_UPDATE = 'custom-declaration/question/';
const URL_ONE_QUESTION = 'question/retrieve/';
const URL_DELETE = 'question/delete/';
const URL_EDIT = 'question/update/';
const URL_REORDER = 'question/reorder/';

const fetchOwnDeclaration = async () => {
  return client.get(URL);
};

const addNewQuestion = async (data: any) => {
  return client.post(URL_UPDATE, data);
};

const fetchOwnQuestion = async (id: number) => {
  return client.get(URL_ONE_QUESTION + id + '/');
};

const deleteOwnQuestion = async (id: number) => {
  return client.delete(URL_DELETE + id);
};

const editOwnQuestion = async (data: any, id: number) => {
  return client.put(URL_EDIT + id + '/', data);
};

const reOrderQuestion = async (data: any) => {
  return client.post(URL_REORDER, data);
};

const actions = {
  fetchOwnDeclaration,
  addNewQuestion,
  fetchOwnQuestion,
  deleteOwnQuestion,
  editOwnQuestion,
  reOrderQuestion,
};

export default actions;
